import { postEvent } from '@/common/cmm-trace'

export function trackEvent(category = '', action = '', opt_label = '', opt_value = '', ext = {}) {
  try {
    console.log('trackEvent', category, action, opt_label, opt_value, ext)
    postEvent('baidu_event', { category, action, opt_label, opt_value, ext: JSON.stringify(ext) })
    // eslint-disable-next-line no-undef
    _hmt.push(['_trackEvent', category, action, opt_label, opt_value])
  } catch (e) {
    console.log(e)
  }
}

/**
 * @deprecated 暂时废弃
 */

function postTrackEvent(category = '', action = '', opt_label = '', opt_value = '', ext = {}) {
  try {
    postEvent('baidu_event', { category, action, opt_label, opt_value, ext: JSON.stringify(ext) })
  } catch (e) {
    console.log(e)
  }
}
